import React, { memo } from "react";
import { Button, useMutation, useNotify, useRedirect } from "react-admin";
import SaveIcon from "@material-ui/icons/Save";
import { useFormState } from "react-final-form";

interface ISaveButtonSubcontractorRateChart {
  formInvalid: boolean;
}

const SaveButtonSubcontractorRateChart = ({
  formInvalid,
}: ISaveButtonSubcontractorRateChart) => {
  const notify = useNotify();
  const redirect = useRedirect();
  const { values } = useFormState();

  const [saveRateChart, { loading }] = useMutation(
    {
      type: "create",
      resource: "subcontractorRateCharts",
      payload: {
        data: {
          ...values,
          busAssistantIncentive: Math.round(
            Number(values.busAssistantIncentiveFee) * 100.0
          ),
          additionalIncentiveRates: {
            smallVehicleFee: Math.round(
              Number(values.additionalIncentiveRates.smallVehicleFeeValue) *
                100.0
            ),
            mediumVehicleFee: Math.round(
              Number(values.additionalIncentiveRates.mediumVehicleFeeValue) *
                100.0
            ),
          },
          capacityIncentiveRates: values.capacityIncentiveRatesToSend ? values.capacityIncentiveRatesToSend : values.capacityIncentiveRates,
          items: [...values.regularItemsToSend, ...values.ccaItemsToSend],
          schoolIncentives: values.schoolIncentivesToSend ? values.schoolIncentivesToSend : values.schoolIncentives,
        },
      },
    },
    {
      onSuccess: ({ res }) => {
        notify("Success Update Subcontractor Rate Charts", "info");
        redirect(`/schools/${res.json.schoolId}/show/6`);
      },
      onFailure: (error) => {
        notify(
          `Failed Update Subcontractor Rate Charts, error: ${error.message}`,
          "error"
        );
      },
    }
  );
  return (
    <Button
      label={loading ? `Loading...` : `Save`}
      disabled={formInvalid || loading}
      onClick={saveRateChart}
    >
      <SaveIcon />
    </Button>
  );
};
export default memo(SaveButtonSubcontractorRateChart);
